<template>
  <div class="search-content">
    <!-- 模式一 跳转指定地址 -->
    <van-row v-if="param && param.type === 'search01'"  class="search-1">
        <van-col :span="24" class="search-1-row">
          <img class="search-icon" src="//project-homedo.oss-cn-shanghai.aliyuncs.com/4131d0b9-d1e4-4a61-b1f3-ba72c860805e_Icon_48px_Search.png" alt="">
          <input type="text" :placeholder="param.placeholder ? `大家都在搜：${param.placeholder[rollActiveIndex].name}` : ''" v-model="search01Model">
          <div @click="goSearchPage" class="search-go-btn">搜索</div>
        </van-col>
    </van-row>
    <!-- 模式二 带有 搜索/取消 -->
    <van-row v-if="param && param.type === 'search02'"  class="search-2">
      <div class="input-content">
        <img class="search-icon" src="//project-homedo.oss-cn-shanghai.aliyuncs.com/4131d0b9-d1e4-4a61-b1f3-ba72c860805e_Icon_48px_Search.png" alt="">
        <input type="text" @focus="param.canel = false" :placeholder="param.placeholder ? `大家都在搜：${param.placeholder[rollActiveIndex].name}` : ''" v-model="search02Model">
        <div v-if="!param.canel" @click="search02" class="search-go-btn">搜索</div>
        <div v-else @click="clearModel('search02Model')" class="search-go-btn">取消</div>
      </div>
      <!-- 热门搜索 -->
      <van-row v-if="param && param.type === 'search02'" v-show="search02Blur" class="hot" v-cloak>
        <van-col :span="23" :offset="1" class="hot-title">热门搜索</van-col>
        <!-- 热词接口数据渲染 -->
        <van-col :span="23" :offset="1"  class="hot-label">
          <div  v-for="(item, index) of keyWords" :key="index" :class="{selected: item.highlight === 1}" @click="selectedLabel(item.name)">{{item.name}}</div>
        </van-col>
      </van-row>
    </van-row>
    <!-- 模式三 带有 筛选功能 -->
    <van-row v-if="param && param.type === 'search03'"  class="search-3">
      <van-col v-if="param.filterType ==='sol'" :span="21" class="search-3-row"><i class="fa fa-search search before" aria-hidden="true"></i><router-link :to="param.url || ''"><input type="text" :placeholder="param.placeholder ? `大家都在搜：${param.placeholder[rollActiveIndex].name}`: ''" v-model="search03Model"></router-link><i @click="clearModel('search03Model')" class="fa fa-times-circle clear last" aria-hidden="true"></i></van-col>
      <van-col :span="21" v-else class="search-3-row news-search"><router-link :to="param.url || ''"><i class="fa fa-search" aria-hidden="true"></i><span>{{param.placeholder}}</span></router-link></van-col>
      <van-col :span="3" class="search-3-btn"><a @click="filtrate">分类</a></van-col>
    </van-row>
    <solOrNewsFilter v-if="param && param.type === 'search03'" @callBack="callBack" :param="search03Param" ref="chiild"></solOrNewsFilter>
  </div>
</template>

<script>
import { Search, Row, Col } from 'vant'
import solOrNewsFilter from '@/view/filter'
import { mapState } from 'vuex'
export default {
  name: 'search',
  /**
   * param参数说明
   * type : search01、search02、search03
   *
   *  search01： 跳转指定页面得搜索框
   *  searchParam: {
        type: 'search01',
        url: '/search', 必传
        placeholder: [{id:1,name:'test'}]
      }

   *  search02 搜索/取消 得搜索框
   *  searchParam: {
        type: 'search02',
        placeholder: [{id:1,name:'test'}],  选传
        callback: 'callback', 必传
        canel: false 必传 （控制 搜索/取消 得显示与隐藏）
      }

   *  search03： 带筛选得搜索框
   *  searchParam: {
        type: 'search03', 必传
        placeholder: [{id:1,name:'test'}],  选传
        callback: 'callback', 必传 （父组件接收子组件抛出数据 方法名称）
        filterType: 'news'     必传  （news/sol   资讯/方案）
      }
   */
  props: ['param'],
  components: { Search, Row, Col, solOrNewsFilter },
  data () {
    return {
      value: '',
      search01Model: '', // search01模式下 input model
      search02Model: '', // search02 模式下 input model
      search02Blur: true,
      search03Model: '', // search03 模式下 input model
      search03Param: { // search03 模式下 筛选 所需参数
        callBack: 'callBack',
        filterType: this.param.filterType,
        showFilter: false
      },
      rollActiveIndex: 0
    }
  },
  computed: {
    ...mapState({
      keyWords: state => state.solution.keyWords
    })
  },
  created () {
    // 监听确认/回车 事件
    window.onkeydown = (e) => {
      if (e.key === 'Enter') {
        if (this.param.type === 'search01') {
          this.goSearchPage()
        }
        if (this.param.type === 'search02') {
          this.search02()
        }
        if (this.search03Model.trim() !== '') {
          this.$emit(this.param.callback, this.search03Model)
        }
      }
    }
    if (this.param.type === 'search02' && this.$route.query.searchVal) {
      this.search02Model = this.$route.query.searchVal
      this.search02()
    }
  },
  methods: {
    goSearchPage () {
      let val = this.search01Model.trim()
      if (!val) {
        val = this.param.placeholder && this.param.placeholder[this.rollActiveIndex] && this.param.placeholder[this.rollActiveIndex].name
      }
      this.$router.push({ path: this.param.url, query: { searchVal: val } })
    },
    /* 返回上一页 */
    back () {
      window.history.back()
    },
    /* 点击搜索抛出搜索条件 */
    search02 () {
      if (!this.search02Model && this.param && this.param.placeholder && this.param.placeholder[this.rollActiveIndex] && this.param.placeholder[this.rollActiveIndex].name) {
        this.search02Model = this.param.placeholder[this.rollActiveIndex].name
      }
      let val = this.search02Model.trim()
      if (!this.search02Model) {
        val = this.param.placeholder && this.param.placeholder[this.rollActiveIndex] && this.param.placeholder[this.rollActiveIndex].name
      }
      if (val !== '') {
        this.param.canel = true
        this.search02Blur = false
        this.$emit(this.param.callback, val)
      }
    },
    /* 点击筛选跳转筛选页面 */
    filtrate () {
      this.$refs.chiild.solFilterPP = {
        selected: false,
        left: 0,
        right: 0,
        name: ''
      }
      this.$refs.chiild.solFilterYT = {
        selected: true,
        left: 0,
        right: 0,
        name: ''
      }
      this.$refs.chiild.solFilterSX = {
        selected: false,
        left: 0,
        right: 0,
        name: ''
      }
      this.search03Param.showFilter = true
    },
    /* 抛出热门搜索 查询条件 */
    selectedLabel (label) {
      this.search02Model = label
      this.param.canel = true
      this.search02Blur = false
      this.$emit(this.param.callback, this.search02Model)
    },
    /* 接收 筛选页抛出 筛选条件 */
    callBack (event) {
      this.$emit(this.param.callback, event)
    },
    clearModel (type) {
      switch (type) {
        case 'search01Model':
          this.search01Model = ''
          break
        case 'search02Model':
          this.search02Model = ''
          this.param.canel = false
          this.search02Blur = true
          this.$emit(this.param.callback, '')
          break
        case 'search03Model':
          this.search03Model = ''
          this.$refs.chiild.solFilterPP.selected = true
          this.$refs.chiild.solFilterPP.right = 0
          this.$refs.chiild.solFilterPP.name = ''
          this.$refs.chiild.solFilterYT.selected = false
          this.$refs.chiild.solFilterYT.right = 0
          this.$refs.chiild.solFilterYT.name = ''
          this.$refs.chiild.solFilterSX.selected = false
          this.$refs.chiild.solFilterSX.right = 0
          this.$refs.chiild.solFilterSX.name = ''
          this.$emit(this.param.callback, {})
          break
        default:
          break
      }
    },
    initRollLabel (len = 0) {
      this.rollTime = setInterval(() => {
        this.rollActiveIndex = this.rollActiveIndex < len - 1 ? this.rollActiveIndex + 1 : 0
      }, 2000)
    }
  },
  watch: {
    [`param.placeholder`] (newV, old) {
      if (newV.length && !old.length) {
        this.initRollLabel(newV.length)
      }
    }
  },
  mounted () {

  },
  destroyed () {
    if (this.rollTime) {
      clearInterval(this.rollTime)
    }
    console.log('ovder')
  }
}
</script>

<style lang="scss" scoped>
$searchInputBkg: #f2f2f2;
$searchBkg: #ffffff;
.search-content{
.search-1{
  display: flex;
  justify-content: center;
  &-row{
     width: 343px;
     height: 36px;
     margin: 8px auto 0;
     line-height: 36px;
     border-radius: 18px;
     color: #6d6d6d;
     background: #FFF;
     display: flex;
     align-items: center;
     justify-content: space-between;
     .search-icon {
       widows: 22px;
       height: 22px;
       margin: 0 4px 0 12px;
     }
     input {
       border: none;
       width: 245px;
       padding-right: 24px;
       box-sizing: border-box;
       color: #000;
     }
     .search-go-btn {
      width: 55px;
      height: 28px;
      opacity: 1;
      background: #2f7bff;
      border-radius: 14px;
      font-size: 13px;
      color: #FFF;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 28px;
      margin-right: 4px;
     }
     span{
        color: #6d6d6d;
        font-size: 13px;
        margin-left: 5px;
        width: 85%;
        display: inline-block;
     }
  }
}
  .search-2{
    .search-icon {
       widows: 22px;
       height: 22px;
       margin: 0 4px 0 12px;
     }
    .input-content{
      width: 343px;
      height: 36px;
      margin: 8px auto 0;
      line-height: 36px;
      border-radius: 18px;
      color: #6d6d6d;
      background: #FFF;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    input{
       border: none;
       width: 245px;
       padding-right: 24px;
       box-sizing: border-box;
       color: #000;
    }
    // .search{
    // }
    // .clear{
    //   margin-top: 6px;
    //   color: #a0a1a7;
    // }
    // a{
    //   font-size: 16px;
    //   color: #1DBFDA;
    // }
    .search-go-btn {
      width: 55px;
      height: 28px;
      opacity: 1;
      background: #2f7bff;
      border-radius: 14px;
      font-size: 13px;
      color: #FFF;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 28px;
      margin-right: 4px;
    }
  }
  .hot{
    margin-top: 12px;
    &-title{
       height: 40px;
       line-height: 40px;
       font-size: 16px;
       color: rgba(0,0,0,0.85);
       font-weight: bold;
     }
    &-label{
       padding-left: 5px;
       font-size: 0px; /* 处理 display: inline-block; 元素间距 */
       div{
         margin-right: 10px;
         margin-bottom: 10px;
         display: inline-block;
         padding-left: 14px;
         padding-right: 14px;
         font-size: 12px;
         border: 1px solid rgba(0,0,0,0.45);
         border-radius: 2px;
         color: rgba(0,0,0,0.65);
         box-sizing: border-box;
         height: 24px;
         line-height: 24px;
         &.selected{
            color: #2f7bff;
            border-color: #2f7bff;
          }
       }
     }
  }
  .search-3{
    height: 44px;
    padding-left: 3%;
    padding-right: 3%;
    width: 94%;
    border-bottom: 1px solid #d8d8d8;
    background-color: white;
    &-row{
       position: relative;
       height: 28px;
       margin-top: 8px;
       border-radius: 14px;
       width: 75%;
       border: 1px solid #D8D8D8;
      input{
        font-size: 12px;
        margin-top: 5px;
        height: 17px;
        border: none;
        margin-left: 30px;
        width: 80%;
      }
      i{
        &.last{
           color: #a0a1a7;
           position: absolute;
           right: 8px;
           top: 7px;
         }
        &.before{
           color: #b2b2b2;
           position: absolute;
           left: 8px;
           top: 7px;
         }
      }
    }
  &-btn{
     height: 30px;
     line-height: 30px;
     width: 60px;
     text-align: center;
     background: #2F7BFF;
     margin:7px 0 7px 20px;
     border-radius: 15px;
      a{
        font-size: 14px;
        color: #ffffff;
      }
   }
  }
}
.text-aling-c{
  text-align: center;
}
  .news-search {
    .fa-search {
      vertical-align: middle;
      margin-left: 8px;
      margin-right: 5px;
    }
    span {
      color: #6d6d6d;
      font-size: 12px;
      margin-top: 4px;
      margin-left: 5px;
      width: 85%;
      display: inline-block;
      height: 13px;
    }
  }
  ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:  rgba(0,0,0,.45)
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color:  rgba(0,0,0,.45)

  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color:  rgba(0,0,0,.45)

  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color:  rgba(0,0,0,.45)
  }
  input {
    caret-color: #2F7BFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/search.vue